import { Icon } from "./Icon.jsx";

// ─── CONFIRM MODAL ────────────────────────────────────────────────────────────
export function ConfirmModal({ title="Confirm", msg, okLabel="Confirm", danger=false, onOk, onCancel }) {
  return (
    <div style={{position:"fixed",inset:0,background:"var(--overlay)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:9999,padding:20,backdropFilter:"blur(4px)"}}
      onClick={onCancel}>
      <div className="card pop-in" style={{maxWidth:380,width:"100%",padding:"28px 28px 24px",borderRadius:4}} onClick={e=>e.stopPropagation()}>
        <h3 style={{fontSize:17,fontWeight:700,marginBottom:10,color:"var(--ink)"}}>{title}</h3>
        <p style={{fontSize:14,color:"var(--ink-soft)",lineHeight:1.65,marginBottom:26}}>{msg}</p>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
          <button className="btn-ghost" style={{padding:"10px 22px",fontSize:13}} onClick={onCancel}>Cancel</button>
          <button onClick={onOk}
            style={{background:danger?"var(--red)":"var(--teal)",color:"var(--on-accent)",border:"none",borderRadius:4,padding:"10px 24px",fontSize:13,fontWeight:700,cursor:"pointer",
              transition:"opacity 0.2s,transform 0.15s"}}
            onMouseEnter={e=>{e.currentTarget.style.opacity="0.88";e.currentTarget.style.transform="translateY(-1px)";}}
            onMouseLeave={e=>{e.currentTarget.style.opacity="1";e.currentTarget.style.transform="none";}}>
            {okLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
